import React, { useEffect, useState } from "react";
import { FiSearch, FiPlus, FiLayers } from "react-icons/fi";
import styles from "./FeatureFlip.module.css";
import ProjectCard from "./ProjectCard";
import CreateProjectModal from "./CreateProjectModal";
import { useGetAllProjects } from "API/Queries/useGetAllProject";
import EmptyState from "../Common/EmptyState/EmptyState";

const FeatureFlip: React.FC = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const { data, refetch: getAllProjects } = useGetAllProjects(searchQuery);
  const [isFirstRender, setFirstRender] = useState(true);

  useEffect(() => {
    if (isFirstRender) {
      setFirstRender(false);
      getAllProjects();
    }

    const debounceId = setTimeout(() => {
      if (!isFirstRender) {
        getAllProjects();
      }
    }, 300);

    return () => {
      clearTimeout(debounceId);
    };
  }, [searchQuery]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>Feature Management</h1>
          <div className={styles.actions}>
            <div className={styles.searchContainer}>
              <div className={styles.searchWrapper}>
                <FiSearch className={styles.searchIcon} />
                <input
                  type="text"
                  placeholder="Search projects..."
                  className={styles.searchInput}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>

            <button
              onClick={() => setShowCreateModal(true)}
              className={styles.createButton}
            >
              <FiPlus />
              Create Project
            </button>
          </div>
        </div>

        {!!data?.length ? (
          <div className={styles.grid}>
            {data.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        ) : (
          <EmptyState
            title="No Projects Found"
            text="We couldn't find any projects matching your search. Try adjusting your search terms or create a new project."
          >
            <button
              onClick={() => setShowCreateModal(true)}
              className={styles.createButton}
            >
              <FiPlus />
              Create Project
            </button>
          </EmptyState>
        )}

        <CreateProjectModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onSubmit={() => getAllProjects()}
        />
      </div>
    </>
  );
};

export default FeatureFlip;
